var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticStyle:{"background":"#f2f3f8"}},[_c('router-view'),_c('notifications',{attrs:{"group":"foo","position":"center center"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }